// ======================================================================
// File: src/modules/ipe/dashboard/crm/components/CRMDetailDrawer.jsx
// Purpose:
// CRM Executive Detail Drawer
// Customer 360 + Maximize/Restore + ERP Workbench UI
// ======================================================================

import React, { useState } from "react";

export default function CRMDetailDrawer({
  open,
  title,
  type,
  data,
  onClose,
}) {
  const [maximized, setMaximized] =
    useState(false);

  const [activeTab, setActiveTab] =
    useState("Overview");

  if (!open) return null;

  const status =
    data?.status ||
    data?.approval_status ||
    type;

  const tabs =
    type === "Customer"
      ? [
          "Overview",
          "Enquiries",
          "Quotations",
          "Orders",
          "Collections",
          "Activity",
        ]
      : [
          "Overview",
          "Activity",
        ];

  return (
    <>
      {/* =====================================================
          BACKDROP
      ===================================================== */}

      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          background:
            "rgba(0,0,0,.35)",
          zIndex: 999,
        }}
      />

      {/* =====================================================
          DRAWER
      ===================================================== */}

      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,

          width: maximized
            ? "100%"
            : "620px",

          maxWidth: "100%",
          height: "100vh",

          background: "#f8fafc",

          zIndex: 1000,

          overflowY: "auto",

          transition:
            "all .25s ease",

          boxShadow:
            "-8px 0 30px rgba(0,0,0,.15)",
        }}
      >
        {/* =====================================================
            HEADER
        ===================================================== */}

        <div
          style={{
            position: "sticky",
            top: 0,
            zIndex: 20,

            background: "#ffffff",

            borderBottom:
              "1px solid #e5e7eb",

            padding: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent:
                "space-between",
              alignItems:
                "flex-start",
            }}
          >
            <div>
              <h2
                style={{
                  margin: 0,
                  fontWeight: 700,
                  color: "#0f172a",
                }}
              >
                {title}
              </h2>

              <div
                style={{
                  color: "#64748b",
                  fontSize: "12px",
                  marginTop: "4px",
                }}
              >
                {type}
              </div>

              {type ===
                "Customer" && (
                <div
                  style={{
                    marginTop: "6px",
                    color:
                      "#16a34a",
                    fontWeight:
                      600,
                    fontSize:
                      "12px",
                  }}
                >
                  Strategic Customer
                </div>
              )}

              <div
                style={{
                  display:
                    "inline-block",

                  marginTop:
                    "10px",

                  padding:
                    "4px 12px",

                  borderRadius:
                    "999px",

                  background:
                    "#dbeafe",

                  color:
                    "#1d4ed8",

                  fontSize:
                    "12px",

                  fontWeight:
                    600,
                }}
              >
                {status}
              </div>
            </div>

            {/* ACTIONS */}

            <div
              style={{
                display: "flex",
                gap: "8px",
              }}
            >
              <button
                onClick={() =>
                  setMaximized(
                    !maximized
                  )
                }
                style={{
                  width: "38px",
                  height: "38px",

                  border:
                    "1px solid #d1d5db",

                  background:
                    "#fff",

                  borderRadius:
                    "8px",

                  cursor:
                    "pointer",
                }}
                title={
                  maximized
                    ? "Restore"
                    : "Maximize"
                }
              >
                {maximized
                  ? "🗗"
                  : "🗖"}
              </button>

              <button
                onClick={onClose}
                style={{
                  width: "38px",
                  height: "38px",

                  border: "none",

                  background:
                    "#f1f5f9",

                  borderRadius:
                    "8px",

                  cursor:
                    "pointer",

                  fontSize:
                    "16px",
                }}
              >
                ✕
              </button>
            </div>
          </div>

          {/* =====================================================
              CUSTOMER KPI STRIP
          ===================================================== */}

          {type ===
            "Customer" && (
            <div
              style={{
                display:
                  "grid",

                gridTemplateColumns:
                  "repeat(5,1fr)",

                gap: "12px",

                marginTop:
                  "20px",
              }}
            >
              <MiniKPI
                title="Revenue"
                value={
                  data?.value ||
                  "₹8.4 Cr"
                }
                color="#2563eb"
              />

              <MiniKPI
                title="Orders"
                value="24"
                color="#16a34a"
              />

              <MiniKPI
                title="Quotes"
                value="5"
                color="#7c3aed"
              />

              <MiniKPI
                title="Enquiries"
                value="12"
                color="#ea580c"
              />

              <MiniKPI
                title="Outstanding"
                value="₹0.8 Cr"
                color="#dc2626"
              />
            </div>
          )}

          {/* =====================================================
              TABS
          ===================================================== */}

          <div
            style={{
              display: "flex",
              gap: "8px",
              flexWrap:
                "wrap",
              marginTop:
                "20px",
            }}
          >
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() =>
                  setActiveTab(
                    tab
                  )
                }
                style={{
                  padding:
                    "8px 14px",

                  border:
                    activeTab === tab
                      ? "1px solid #2563eb"
                      : "1px solid #d1d5db",

                  background:
                    activeTab === tab
                      ? "#eff6ff"
                      : "#fff",

                  color:
                    activeTab === tab
                      ? "#2563eb"
                      : "#374151",

                  borderRadius:
                    "8px",

                  fontSize:
                    "12px",

                  fontWeight:
                    600,

                  cursor:
                    "pointer",
                }}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* =====================================================
            BODY
        ===================================================== */}

        <div
          style={{
            padding: "20px",
          }}
        >
          {/* =====================================================
              OVERVIEW TAB
          ===================================================== */}

          {activeTab ===
            "Overview" && (
            <>
              <SectionTitle
                title="Overview"
              />

              <div
                style={{
                  display:
                    "grid",

                  gridTemplateColumns:
                    "1fr 1fr",

                  gap: "12px",

                  marginBottom:
                    "24px",
                }}
              >
                {Object.entries(
                  data || {}
                ).map(
                  (
                    [
                      key,
                      value,
                    ]
                  ) => (
                    <div
                      key={
                        key
                      }
                      style={{
                        background:
                          "#fff",

                        border:
                          "1px solid #e5e7eb",

                        borderRadius:
                          "10px",

                        padding:
                          "14px",
                      }}
                    >
                      <div
                        style={{
                          fontSize:
                            "11px",

                          color:
                            "#64748b",

                          marginBottom:
                            "6px",

                          textTransform:
                            "capitalize",
                        }}
                      >
                        {key.replaceAll(
                          "_",
                          " "
                        )}
                      </div>

                      <div
                        style={{
                          fontWeight:
                            700,

                          color:
                            "#111827",
                        }}
                      >
                        {value}
                      </div>
                    </div>
                  )
                )}
              </div>
            </>
          )}

          {/* =====================================================
              OTHER TABS
          ===================================================== */}

          {activeTab !==
            "Overview" && (
            <div
              style={{
                background:
                  "#fff",

                border:
                  "1px solid #e5e7eb",

                borderRadius:
                  "12px",

                padding:
                  "20px",

                marginBottom:
                  "24px",
              }}
            >
              <h3
                style={{
                  marginTop: 0,
                }}
              >
                {activeTab}
              </h3>

              <div
                style={{
                  color:
                    "#64748b",

                  lineHeight:
                    "1.8",
                }}
              >
                {activeTab}
                {" "}
                details will be
                loaded from CRM
                APIs in the next
                phase.
              </div>
            </div>
          )}

          {/* =====================================================
              ACTIVITY SUMMARY
          ===================================================== */}

          <div
            style={{
              background:
                "#fff",

              border:
                "1px solid #e5e7eb",

              borderRadius:
                "12px",

              padding:
                "18px",

              marginBottom:
                "24px",
            }}
          >
            <h3
              style={{
                marginTop: 0,
              }}
            >
              Activity Summary
            </h3>

            <div
              style={{
                color:
                  "#64748b",

                fontSize:
                  "13px",

                lineHeight:
                  "1.8",
              }}
            >
              Approval history,
              workflow actions,
              comments,
              attachments,
              emails,
              notifications,
              audit trail and
              CRM interactions
              will appear here.
            </div>
          </div>

          {/* =====================================================
              ACTIONS
          ===================================================== */}

          <div
            style={{
              display: "flex",
              gap: "10px",
              flexWrap:
                "wrap",
            }}
          >
            <button
              style={{
                background:
                  "#2563eb",

                color: "#fff",

                border: "none",

                borderRadius:
                  "8px",

                padding:
                  "10px 18px",

                cursor:
                  "pointer",
              }}
            >
              View Full Details
            </button>

            <button
              style={{
                background:
                  "#fff",

                border:
                  "1px solid #d1d5db",

                borderRadius:
                  "8px",

                padding:
                  "10px 18px",

                cursor:
                  "pointer",
              }}
            >
              Export
            </button>

            <button
              onClick={onClose}
              style={{
                background:
                  "#fff",

                border:
                  "1px solid #d1d5db",

                borderRadius:
                  "8px",

                padding:
                  "10px 18px",

                cursor:
                  "pointer",
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

/* =========================================================
   HELPERS
========================================================= */

function SectionTitle({
  title,
}) {
  return (
    <div
      style={{
        fontSize: "16px",
        fontWeight: 700,
        color: "#0f172a",
        marginBottom: "12px",
      }}
    >
      {title}
    </div>
  );
}

function MiniKPI({
  title,
  value,
  color,
}) {
  return (
    <div
      style={{
        background: "#fff",
        border:
          "1px solid #e5e7eb",
        borderRadius: "10px",
        padding: "12px",
      }}
    >
      <div
        style={{
          fontSize: "11px",
          color: "#64748b",
        }}
      >
        {title}
      </div>

      <div
        style={{
          marginTop: "4px",
          fontWeight: 700,
          color,
        }}
      >
        {value}
      </div>
    </div>
  );
}